import {
  Divider,
  Drawer,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Stack,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { botActions } from "store/bot";
import { useDispatch, useSelector } from "react-redux";
import SettingsIcon from "@mui/icons-material/Settings";
import { createBotActions } from "store/createBot";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import GroupsIcon from "@mui/icons-material/Groups";
import GroupsModal from "components/groups/GroupsModal";
import CreateBotModal from "components/bot/CreateBotModal";
import BotAvatar from "components/bot/BotAvatar";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LogoutButton from "components/react-lib/firebase-auth/LogoutButton";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { useLocation, useNavigate } from "react-router-dom";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { useGlobalRefs } from "context/react-lib/generic-ui/GlobalRefContext";
import PricingModal from "components/pricing/PricingModal";
import EditDocumentModal from "components/react-lib/generic-ui/modals/EditDocumentModal";
import { popupActions } from "store/react-lib/generic-ui/popup";
import CreditAccountsModal from "../account/CreditAccountsModal";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { COLLECTIONS } from "firebaseCollections";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTheme } from "@emotion/react";
import { MODALS } from "modals";
import ModelLabel from "components/model/ModelLabel";
import ChatIcon from "@mui/icons-material/Chat";
import ImageIcon from "@mui/icons-material/Image";
import MenuBookIcon from '@mui/icons-material/MenuBook';

export default function MainMenu() {
  const theme = useTheme();

  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const botState = useSelector((state) => state.bot);

  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [groupsModalOpen, setGroupsModalOpen] = useState(false);
  const [userModalOpen, setUserModalOpen] = useState(false);

  const bots = botState.bots;
  const auth = useAuth();
  const uid = auth.currentUser.uid;
  const currentBot = botState.current;

  const menuRef = useRef();
  const globalRefs = useGlobalRefs();
  globalRefs.modalFocusRef = menuRef;

  const handleSelectBot = (botId) => {
    dispatch(botActions.selectBot(botId));
    setMenuOpen(false);
  };

  const handleCreateBot = () => {
    dispatch(createBotActions.reset());
    dispatch(modalsActions.openModal(MODALS.createEditBotModal));
  };

  const handleEdit = (event, bot) => {
    event.stopPropagation();
    dispatch(createBotActions.initializeFromBot(bot));
    dispatch(modalsActions.openModal(MODALS.createEditBotModal));
    setMenuOpen(false);
    setModalOpen(true);
  };

  const handleEditProfile = () => {
    setMenuOpen(false);
    setProfileModalOpen(true);
  };

  const handleEditGroups = () => {
    setMenuOpen(false);
    setGroupsModalOpen(true);
  };

  const formatName = (name) => {
    if (name.length > 24) {
      return `${name.substring(0, 24)}...`;
    }
    return name;
  };

  const handleOpenModal = (modalName) => () => {
    setMenuOpen(false);
    dispatch(modalsActions.openModal(modalName));
  };

  return (
    <>
      <IconButton
        onClick={() => setMenuOpen(true)}
        color="text"
        data-testid="main-menu-button"
        ref={menuRef}
      >
        <MenuIcon />
      </IconButton>

      <CreateBotModal open={modalOpen} setOpen={setModalOpen} />
      <CreditAccountsModal />
      <GroupsModal />
      <PricingModal />

      <EditDocumentModal
        name="contact"
        title="Contact Us"
        documentRef={collection(db, COLLECTIONS.supportRequests)}
        fieldsToEdit={["type", "message"]}
        isCreate={true}
        createExtraData={{
          uid,
          createdAt: new Date().getTime(),
        }}
        saveCallback={() =>
          dispatch(
            popupActions.showSuccess(
              "Message sent! Thank you for your contact."
            )
          )
        }
        errorCallback={() =>
          dispatch(
            popupActions.showError("Couldn't send message. Try again later.")
          )
        }
        fieldConfig={{
          type: {
            props: {
              color: "secondary",
            },
          },
          message: {
            props: {
              color: "secondary",
            },
          },
        }}
      />
      <Drawer
        data-testid="main-menu-drawer"
        open={menuOpen}
        anchor="left"
        onClose={() => setMenuOpen(false)}
      >
        <MenuList
          sx={{
            overflowY: "auto",
          }}
        >
          <MenuItem>
            <LogoutButton
              color="secondary"
              fullWidth
              variant="contained"
              startIcon={<LogoutIcon />}
            />
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => navigate("/")}
            data-testid="chat-menu-item"
            selected={location.pathname === "/"}
          >
            <ListItemIcon>
              <QuestionAnswerIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>AI Chat</ListItemText>
          </MenuItem>
          {/* {auth.currentUser &&
            ["fran.aubry@gmail.com", "yaya1204hk@gmail.com"].includes(
              auth.currentUser.email
            ) && (
              <MenuItem
                onClick={() => navigate("/talk")}
                data-testid="chat-menu-item"
                selected={location.pathname === "/talk"}
              >
                <ListItemIcon>
                  <ChatIcon
                    sx={{ color: theme.palette.menuIcon.main }}
                  />
                </ListItemIcon>
                <ListItemText>Talk</ListItemText>
              </MenuItem>
            )} */}
          {/* {auth.currentUser &&
            ["fran.aubry@gmail.com", "yaya1204hk@gmail.com"].includes(
              auth.currentUser.email
            ) && (
              <MenuItem
                onClick={() => navigate("/audio")}
                data-testid="chat-menu-item"
                selected={location.pathname === "/audio"}
              >
                <ListItemIcon>
                  <ChatIcon
                    sx={{ color: theme.palette.menuIcon.main }}
                  />
                </ListItemIcon>
                <ListItemText>Audio</ListItemText>
              </MenuItem>
            )} */}
          <MenuItem
            onClick={() => navigate("/editor")}
            data-testid="editor-menu-item"
            selected={location.pathname === "/editor"}
          >
            <ListItemIcon>
              <TextSnippetIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>AI Editor</ListItemText>
          </MenuItem>
          {auth.currentUser &&
            ["fran.aubry@gmail.com"].includes(auth.currentUser.email) && (
              <MenuItem
                onClick={() => navigate("/docs")}
                data-testid="editor-menu-item"
                selected={location.pathname === "/docs"}
              >
                <ListItemIcon>
                  <TextSnippetIcon
                    sx={{ color: theme.palette.menuIcon.main }}
                  />
                </ListItemIcon>
                <ListItemText>AI Editor V2</ListItemText>
              </MenuItem>
            )}
          {auth.currentUser &&
            ["fran.aubry@gmail.com"].includes(auth.currentUser.email) && (
              <MenuItem
                onClick={() => navigate("/aiMenu")}
                data-testid="editor-menu-item"
                selected={location.pathname === "/aiMenu"}
              >
                <ListItemIcon>
                  <MenuBookIcon
                    sx={{ color: theme.palette.menuIcon.main }}
                  />
                </ListItemIcon>
                <ListItemText>AI Menu</ListItemText>
              </MenuItem>
            )}
          <MenuItem
            onClick={() => navigate("/images")}
            data-testid="editor-menu-item"
            selected={location.pathname === "/images"}
          >
            <ListItemIcon>
              <ImageIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>Image Studio</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => navigate("/files")}
            data-testid="files-menu-item"
            selected={location.pathname === "/files"}
          >
            <ListItemIcon>
              <FilePresentIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>File Manager</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => navigate("/bookmarks")}
            data-testid="saved-menu-item"
            selected={location.pathname === "/bookmarks"}
          >
            <ListItemIcon>
              <BookmarkIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>Bookmarks</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={handleOpenModal("profile")}
            data-testid="profile-menu-item"
          >
            <ListItemIcon>
              <AccountCircleIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={handleOpenModal("contact")}
            data-testid="credit-accounts-menu-item"
          >
            <ListItemIcon>
              <ContactSupportIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>Contact Us</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={handleOpenModal("pricing")}
            data-testid="credit-accounts-menu-item"
          >
            <ListItemIcon>
              <MonetizationOnIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>Pricing</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={handleOpenModal("creditAccounts")}
            data-testid="credit-accounts-menu-item"
          >
            <ListItemIcon>
              <AccountBalanceWalletIcon
                sx={{ color: theme.palette.menuIcon.main }}
              />
            </ListItemIcon>
            <ListItemText>Credit Accounts</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={handleOpenModal("groups")}
            data-testid="groups-menu-item"
          >
            <ListItemIcon>
              <GroupsIcon sx={{ color: theme.palette.menuIcon.main }} />
            </ListItemIcon>
            <ListItemText>Groups</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={handleCreateBot}
            data-testid="create-bot-menu-item"
          >
            <ListItemIcon>
              <AddCircleOutlineIcon
                sx={{ color: theme.palette.menuIcon.main }}
              />
            </ListItemIcon>
            <ListItemText>Create Bot</ListItemText>
          </MenuItem>
          <Divider />
          {bots.map((bot) => (
            <MenuItem
              data-testclass="main-menu-bot-item"
              key={bot.id}
              onClick={() => handleSelectBot(bot.id)}
              selected={bot.id === currentBot}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
                width="100%"
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  pl={2}
                  sx={{
                    cursor: "pointer",
                  }}
                  spacing={1}
                >
                  <BotAvatar botId={bot.id} />
                  <Stack>
                    <Typography>{formatName(bot.name)}</Typography>
                    <ModelLabel modelId={bot.model} variant="caption" />
                  </Stack>
                </Stack>
                <IconButton onClick={(event) => handleEdit(event, bot)}>
                  <SettingsIcon />
                </IconButton>
              </Stack>
            </MenuItem>
          ))}
        </MenuList>
      </Drawer>
    </>
  );
}
